import { useEffect } from 'react';
import { ReferralForProviderResult } from '../../providerapp/hook/useReferralQueryForProvider$';
import { Referral } from './types';

export function useSelectedReferral (setReferral: (referral: Referral) => void, selectedReferralUuid: string | null, data?: ReferralForProviderResult,) {
    useEffect(() => {
        if (!!data) {
            const referral = data.providerReferralQuery.edges.find((e) => e.node?.guid === selectedReferralUuid);
            if (referral) {
                setReferral(referral.node);
            }
        }
    }, [data, setReferral, selectedReferralUuid]);
}

export class SelectedReferral {
    static QS_PARAM_NAME = 'selected';

    static uuidFromQueryString(): string | null {
        const queryStr = (new URL(document.location.href)).searchParams;
        return queryStr.get(this.QS_PARAM_NAME); // referral uuid
    }

    static createSelectedReferralLink(referralGuid: string, rootUrl: string) {
        const qs = new URLSearchParams();
        qs.set(this.QS_PARAM_NAME, referralGuid);

        return `${rootUrl}/referral?${qs.toString()}`;
    }

    static createReferralNewOfferLink (referralGuid: string, rootUrl: string) {
        return `${rootUrl}/offer/new?referralGuid=${referralGuid}`;
    }

    static filterSiblingReferralsForOffer (referral: Referral) {
        return (referral.clientSiblingReferrals || []).filter((s) => !s.hasOffers);
    }
}
